<!--<amplify-authenticator>
	<amplify-sign-in slot="sign-in">
		<div slot="secondary-footer-content"></div>
	</amplify-sign-in>
	<router-outlet></router-outlet>
</amplify-authenticator>-->
<router-outlet></router-outlet>